module.exports = __webpack_public_path__ + "img/icon_mine_map.a3ea78a7.png";